import { observable, action } from "mobx";
import organizationService from "~/services/OrganizationService";

export class OrganizationStore {
  @observable organization = {};
  @observable organizationId = 0;
  @observable organizationSelected = {};
  @observable organizationLogoUrl = "";

  @action.bound
  getOrganizations = async (filter, organizationId, addEmptyItem, skip, resaleId) => {
    if (skip === undefined) skip = 0;
    const data = await organizationService.getAll(filter, addEmptyItem, skip, resaleId);
    if (!data || data === "") return [];

    if (organizationId === undefined || organizationId === 0) return data;
  
    let organizationsFilter = [];
    for (let i = 0; i < data.organizations.length; i++){
      if (data.organizations[i].organizationId === organizationId) {
        organizationsFilter.push(data.organizations[i]);
        break;
      }
    }
    
    if (organizationsFilter.length === 0) {
      organizationsFilter.push(await organizationService.getById(organizationId));
    }

    data.organizations = organizationsFilter;

    return data;    
  };

  @action.bound
  getResales = async (filter) => {
    const data = await organizationService.getResales(filter);
    if (!data || data === "") return [];
    return data;    
  };

  @action.bound
  setOrganizationSelected = (organizationSelected) => {
    this.organizationSelected = organizationSelected;
  }

  @action.bound
  getOrganizationSelected = () => {
    return this.organizationSelected;
  }

  @action.bound
  getOrganization = async (organizationId) => {
    const data = await organizationService.getById(organizationId);
    return data ?? {};
  };

  @action.bound
  getResaleLogo = async (location) => {
    try {
      const path = location.pathname.split("/");
      return await organizationService.getResaleLogo(path[1]);
    } 
    catch {
      return "";
    }
  };

  @action.bound
  existResaleName = async (resaleName, organizationId) => {
    return await organizationService.existResaleName(resaleName, organizationId);
  };

  @action.bound
  getResalePrefix = async (location) => {
    try {
      const segments = location.pathname.split("/").filter(Boolean);
      const resaleLogo = await this.getResaleLogo(location);
      if (resaleLogo !== "" && resaleLogo !== null) {
        document.title = segments[0];
        document.querySelectorAll('link[rel~="icon"]').forEach(el => el.remove());
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = 'data:,';
        document.head.appendChild(link);
        return segments[0];
      }
      else {
        document.title = "E-Price";
        return "";
      }
    } catch {
      return "";
    }
  };
  
  @action.bound
  maintainOrganization = async (formData) => {    
    return await organizationService.maintain(formData);
  };

  @action.bound
  logout = async () => {
    this.organization = {}; 
  }

  @action.bound
  setOrganizationId = (organizationId) => {
    this.organizationId = parseInt(organizationId);
  }

  @action.bound
  getOrganizationId = () => {
    return this.organizationId;
  }

  @action.bound
  setOrganizationLogoUrl = (organizationLogoUrl) => {
    this.organizationLogoUrl = organizationLogoUrl;
  }

  @action.bound
  getOrganizationLogoUrl = () => {
    return this.organizationLogoUrl;
  }

  @action.bound
  statusUpdate = async (organizationId) => {
    return await organizationService.statusUpdate(organizationId);
  }  
}

const organizationStore = new OrganizationStore();
export default organizationStore;
